export const routeSlugs = {
  cs: {
    prefixes: {
      election: "volby",
    },
    pages: {
      introduction: "uvod",
      guide: "navod",
      question: "otazka",
      review: "rekapitulace",
      result: "vysledek",
      comparison: "porovnani",
    },
  },
} as const;
